import { PuzzleButtonPagesContainer } from "./PuzzleButtonPagesContainer";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";
import { GameManager } from "../GameManager";

export class PuzzleSelectionState extends Phaser.State {

    public static currentInstance: PuzzleSelectionState;

    public puzzleButtonPagesContainer: PuzzleButtonPagesContainer;
    
    public init(): void {

        PuzzleSelectionState.currentInstance = this;
    }

    public create(): void {

        const backgroundImage = this.add.image(0, 0, "texture_atlas_1", "bg.png");
        backgroundImage.scale.set(2);

        this.puzzleButtonPagesContainer = new PuzzleButtonPagesContainer(this.game);
        this.add.existing(this.puzzleButtonPagesContainer);

        // EL MARCO DE MADERA
        // top
        const topFrame = this.add.image(0, 0, "texture_atlas_1", "frame_top.png");
        
        // bottom
        const bottomFrame = this.add.image(0, GameConstants.GAME_HEIGHT, "texture_atlas_1", "frame_bottom.png");
        bottomFrame.anchor.y = 1;

        // left
        const leftFrame = this.add.image(0, topFrame.height, "texture_atlas_1", "frame_left.png");
        leftFrame.scale.y = (GameConstants.GAME_HEIGHT - topFrame.height - bottomFrame.height) / leftFrame.height;

        const rightFrame = this.add.image(GameConstants.GAME_WIDTH, topFrame.height, "texture_atlas_1", "frame_right.png");
        rightFrame.anchor.x = 1;
        rightFrame.scale.y = (GameConstants.GAME_HEIGHT - topFrame.height - bottomFrame.height) / rightFrame.height;

        const tab = this.add.image(0, 0, "texture_atlas_1", "menu_tab.png");
        tab.scale.y = GameVars.scaleY;
        
        const buttonHome = this.add.button(45, 45 * GameVars.scaleY, "texture_atlas_1", this.onClickHome, this);
        buttonHome.setFrames("button_home_on.png", "button_home_off.png", "button_home_on.png");
        buttonHome.forceOut = true;
        buttonHome.anchor.set(.5);
        buttonHome.scale.y = GameVars.scaleY;

        const titleLabel = this.add.text(GameConstants.GAME_WIDTH / 2, 14 * GameVars.scaleY, GameVars.puzzleMoves + " " + GameVars.texts[GameVars.language]["MOVES PUZZLES"], { font: "42px Roboto Slab Regular", fill: "#1b2d3d", align: "center"}); 
        titleLabel.scale.y = GameVars.scaleY;
        titleLabel.anchor.x = .5;

        this.game.camera.flash(0x000000, GameConstants.TIME_FADE, false);
    }

    public shutdown(): void {

        PuzzleSelectionState.currentInstance = null;
        
        super.shutdown();
    }

    private onClickHome(): void {

        AudioManager.playSound("click"); 

        GameManager.enterHomeScene();
    }
}
